/* eslint-disable */

import {
  ZModal,
  ZIcon,
  ZText,
  ZLoading,
  ZDisplay,
  ZButton,
  ZTitle,
  ZCard,
  ZDivider,
  ZInputField,
  ZInput,
  ZCheckbox,
  ZButtonSocial,
  ZLink,
  ZBadgeText
} from '@quero/zilla-vue';

export default {
  install(Vue) {
    this.installAtoms(Vue);
    this.installMolecules(Vue);
  },
  installAtoms(Vue) {
    Vue.component('z-divider', ZDivider);
    Vue.component('z-display', ZDisplay);
    Vue.component('z-text', ZText);
    Vue.component('z-title', ZTitle);
    Vue.component('z-icon', ZIcon);
    Vue.component('z-loading', ZLoading);
    Vue.component('z-button', ZButton);
    Vue.component('z-button-social', ZButtonSocial);
    Vue.component('z-card', ZCard);
    Vue.component('z-card', ZCard);
    Vue.component('z-input', ZInput);
    Vue.component('z-link', ZLink);
    Vue.component('z-badge-text', ZBadgeText);
  },
  installMolecules(Vue) {
    Vue.component('z-modal', ZModal);
    Vue.component('z-input-field', ZInputField);
    Vue.component('z-checkbox', ZCheckbox);
  },
};
